import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import PF2MAlertDialog from '~/components/PF2MAlertDialog';
import Footer from '~/pages/Manager/Footer';
import { useTranslation } from 'react-i18next';
import styles from '../styles';
import {
  setMaintenanceTurnGroupValue,
  resetMaintenanceTurnGroup,
  updateMaintenanceTurnGroup,
} from '~/store/maintenance/actions';
import { getTurnsGroups } from '~/store/manager/actions';
import PF2MSearchSelectOutlined from '~/components/PF2MSearchSelectOutlined';

const TurnTab = ({ classes }) => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const turnsGroups = useSelector(state => state.manager.turnsGroups);
  const turnGroup = useSelector(state => state.maintenance.turnGroup);
  const isTurnGroupDirty = useSelector(state => state.maintenance.isTurnGroupDirty);
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();

  useEffect(() => {
    async function fetchData() {
      dispatch(getTurnsGroups());
    }
    if (!dataLoaded) {
      fetchData();
      setDataLoaded(true);
    }
  }, [dataLoaded, dispatch]);

  return (
    <div className={classes.tabContainer}>
      <div style={{
        flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      >
        <div className={classes.containerTypeSelector}>
          <div>
            <span className={classes.labelTypeSelector}>
              {`${translate('common:ShiftGroupConnectedToMaintenanceModule')}:`}
            </span>
            <PF2MSearchSelectOutlined
              value={turnGroup}
              onChange={e => dispatch(setMaintenanceTurnGroupValue(e.target.value))}
            >
              {[{ value: 0, label: translate('common:NotConnected') }]
                .concat(...turnsGroups
                  .map(e => ({ value: e.id, label: e.name })))}
            </PF2MSearchSelectOutlined>
          </div>
        </div>
      </div>
      <Footer
        isDirty={isTurnGroupDirty}
        discard={() => dispatch(resetMaintenanceTurnGroup())}
        sendData={() => dispatch(updateMaintenanceTurnGroup(turnGroup))}
      />
      <PF2MAlertDialog
        hasCancel={false}
        confirmText={translate('common:Understood')}
        description={translate('validation:YouHaveUnsavedData')}
        open={isAlertOpen}
        onConfirm={() => setIsAlertOpen(false)}
      />
    </div>
  );
};

TurnTab.propTypes = {
  classes: PropTypes.object.isRequired,
};

TurnTab.defaultProps = {};

export default withStyles(styles)(TurnTab);
